import React from 'react';
import { Avatar, AvatarProps, Box } from '@mui/material';
import CustomIcon from './CustomIcon';

interface Props extends AvatarProps {
  Icon: Icon;
  canHaveStroke?: boolean;
  archived?: boolean;
}

const IconCircle: React.FC<Props> = ({
  className, Icon, archived, canHaveStroke, sx, ...otherProps
}: Props) => (
  <Avatar
    className={className}
    sx={[
      (t) => ({
        backgroundColor: 'white',
        borderRadius: '50%',
        borderWidth: canHaveStroke ? 3 : 1,
        borderStyle: 'solid',
        borderColor: canHaveStroke
          ? (archived ? t.palette.primary4 : t.palette.primary1)
          : t.palette.primary4,
      }),
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
    {...otherProps}
  >
    <Box sx={(t) => ({ margin: t.spacing(1), color: t.palette.primary4 })}>
      <CustomIcon icon={Icon} />
    </Box>
  </Avatar>
);

export default IconCircle;
